<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CheckModal from "@/components/CheckModal";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import legalMatrixAPI from "@/services/standards/legalMatrix/legalMatrixAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { dateFormat } from "@/utils/helpers/format";

/**
 * 2.7.1 Matriz Legal — listado de revisiones.
 * Reemplaza el grid confuso por captura estructurada (catálogo de requisitos + estado de cumplimiento)
 * + PDF branded firmado. Cada fila es una revisión versionable; el detalle/firma vive en matriz-legal-editar.
 */
export default {
  page: {
    title: "Matriz legal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal },
  data() {
    return {
      title: "2.7.1 Matriz legal",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "Matriz legal", active: true },
      ],
      itemData: null,
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      lista: [],
      yearFilter: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  computed: {
    yearOptions() {
      const current = new Date().getFullYear() + 1;
      const years = [];
      for (let y = current; y >= 2020; y--) years.push(y);
      return years;
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(18)
        .then((response) => { this.itemData = response; })
        .catch((error) => { console.log(error); });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 18)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => { console.log(error); });
    },

    changeItemStatus(itemStatus) {
      const itemChange = { companies_id: this.companyID, item_id: 18, status: itemStatus };
      newScoresAPI.calculateScores(itemChange)
        .then(() => {
          Swal.fire({ title: "¡Éxito!", text: "¡Se ha cambiado el estado del ítem con éxito!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1000);
        })
        .catch((error) => {
          Swal.fire({ title: "¡ERROR!", text: "¡No se ha actualizado el estado del ítem!", icon: "error", confirmButtonClass: "btn btn-confirm mt-2" });
          setTimeout(() => window.location.reload(), 1000);
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (classificationID === 1 && item.obligatory_UPA === 1) return true;
        if (classificationID === 2 && item.obligatory_groupI === 1) return true;
        if (classificationID === 3 && item.obligatory_groupII === 1) return true;
        if (classificationID === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (role) {
        if (roles) {
          role = roles.includes(role) ? true : false;
        } else {
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        }
        const permissions = this.$store.state.auth.info.permissions;
        const enabled = permissions.find((permission) => permission.name === name);
        return enabled && role ? true : false;
      }
      return false;
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    statusBadgeClass(status) {
      return status === "signed" ? "badge-success" : "badge-secondary";
    },
    statusText(status) {
      return status === "signed" ? "Firmada" : "Borrador";
    },

    downloadFormat() {
      const url = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/MATRIZ_LEGAL_SST_COMPLETA.xlsx";
      window.open(url, "_blank");
    },

    downloadReview(id) {
      window.open(legalMatrixAPI.pdfUrl(id), "_blank");
    },

    newReview() {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/matriz-legal-revision` });
    },

    // Acceso a la matriz legal diligenciada anteriormente (grid del flujo anterior).
    openLegacyMatriz() {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/matriz-legal-2` });
    },

    editReview(id) {
      this.$router.push({ path: `/forms/estandares/${this.companyID}/matriz-legal-revision/${id}` });
    },

    deleteReview(id) {
      Swal.fire({
        title: "¿Eliminar revisión?",
        text: "Se eliminará la revisión y sus estados de cumplimiento.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (!res.value) return;
        legalMatrixAPI.delete(id)
          .then(() => {
            Swal.fire({ title: "Éxito", text: "Revisión eliminada.", icon: "success", timer: 1500, showConfirmButton: false });
            this.getList();
          })
          .catch((error) => {
            console.log(error);
            Swal.fire("Error", "No se pudo eliminar la revisión", "error");
          });
      });
    },

    applyYearFilter() {
      this.getList();
    },

    getList() {
      this.loading = true;
      legalMatrixAPI.getAll(this.companyID, 1, this.yearFilter)
        .then((response) => {
          this.lista = (response && response.List && response.List.data) ? response.List.data : [];
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },

  mounted() {
    this.getItemData();
    this.getItems();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe evaluar el cumplimiento de las normas vigentes en Seguridad y Salud en el Trabajo.
                      Crea una revisión, marca el <strong>Estado de Cumplimiento</strong> de cada requisito (Cumple /
                      Parcial / No Cumple / No Aplica) y la plataforma genera la Matriz Legal con cuadro de mando, lista
                      para la firma del Representante Legal.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-md-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="openLegacyMatriz" class="btn btn-outline-secondary mx-1"
                    title="Consultar la matriz legal diligenciada anteriormente">
                    <i class="mdi mdi-table-eye"></i> Matriz legal anterior
                  </button>
                  <button :disabled="!allowAccess()" @click="downloadFormat" class="btn btn-light mx-1">
                    <i class="bx bx-download"></i> Descargar formato (Excel)
                  </button>
                  <button :disabled="!allowAccess() || !getRole('Crear')" @click="newReview" class="btn btn-primary mx-1">
                    <i class="mdi mdi-plus"></i> Nueva revisión
                  </button>
                </div>
              </div>

              <div class="row pt-2">
                <div class="form-row col-md-6 col-sm-12">
                  <b-form-group class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="form-row col-md-6 col-sm-12">
                  <b-form-group class="col-sm-12" label="Filtrar por año">
                    <b-form-select v-model="yearFilter" @change="applyYearFilter" plain class="form-control">
                      <b-form-select-option :value="null">Todos los años</b-form-select-option>
                      <b-form-select-option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr v-if="getRole('Consultar')" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="table-responsive">
                    <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                      <thead>
                        <tr>
                          <th class="text-center align-middle">Fecha</th>
                          <th class="text-center align-middle">Versión</th>
                          <th class="text-center align-middle">Normas evaluadas</th>
                          <th class="text-center align-middle">Estado</th>
                          <th class="text-center align-middle">Descargar PDF</th>
                          <th class="text-center align-middle">Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-if="loading">
                          <td colspan="6" class="text-center"><b-spinner variant="primary" small></b-spinner></td>
                        </tr>
                        <tr v-else-if="!lista.length">
                          <td colspan="6" class="text-center text-muted">No hay revisiones registradas.</td>
                        </tr>
                        <tr v-for="dato in lista" :key="dato.id">
                          <td class="text-center align-middle">{{ dateConvert(dato.fecha) }}</td>
                          <td class="text-center align-middle">{{ dato.version }}</td>
                          <td class="text-center align-middle">{{ dato.evaluated_count }}</td>
                          <td class="text-center align-middle">
                            <span class="badge" :class="statusBadgeClass(dato.workflow_status)">
                              {{ statusText(dato.workflow_status) }}
                            </span>
                          </td>
                          <td class="text-center align-middle">
                            <button :disabled="!allowAccess()" style="background-color: transparent !important; border: none;"
                              type="button" @click="downloadReview(dato.id)" title="Descargar PDF branded">
                              <i class="mdi mdi-file-pdf-box" style="font-size:1.4rem; color:#c0392b;"></i>
                            </button>
                          </td>
                          <td class="text-center align-middle">
                            <b-dropdown :disabled="!allowAccess()" variant="primary" size="sm">
                              <template v-slot:button-content><i class="mdi mdi-eye"></i></template>
                              <b-dropdown-item :disabled="!getRole('Editar')" @click="editReview(dato.id)">
                                {{ dato.workflow_status === 'signed' ? 'Ver' : 'Editar' }}
                              </b-dropdown-item>
                              <b-dropdown-item :disabled="!getRole('Eliminar')" @click="deleteReview(dato.id)">Eliminar</b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
